import { useMemo } from 'react';
import { Typography } from '@mui/material';

import Number from 'src/components/common/Number';
import { fix, gt } from 'src/utils/number';

import { AmountContainer, Base02TextContainer, Container, InfoBodyContainer, InfoTextContainer, TitleContainer } from './styled';

type TxDetailsProps = {
  estimatedGasFee: string;
};

export default function TxDetails({ estimatedGasFee }: TxDetailsProps) {
  const gasFee = useMemo(() => String(parseFloat(estimatedGasFee)), [estimatedGasFee]);
  return (
    <Container>
      <>
        <TitleContainer>
          <Typography variant="h3">Details</Typography>
        </TitleContainer>
        <InfoBodyContainer>
          <InfoTextContainer>
            <Base02TextContainer>
              <Typography variant="h7">Estimated Gas Fee</Typography>
            </Base02TextContainer>

            {gt(gasFee, '0') ? (
              <AmountContainer>
                <Typography variant="h4">~</Typography>
                &nbsp;
                <Number typoOfIntegers="h4" typoOfDecimals="h6">
                  {String(parseFloat(fix(gasFee, 6)))}
                </Number>
                &nbsp;
                <Typography variant="h6">DYDX</Typography>
              </AmountContainer>
            ) : (
              <Typography variant="h6">-</Typography>
            )}
          </InfoTextContainer>
        </InfoBodyContainer>
      </>
    </Container>
  );
}
